var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThumbsDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icn/thumbs-down") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icn/thumbs-down",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-21",
    transform: "translate(3.000000, 3.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "dislike-1",
    fill: "#E53935",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,10.2350573 C0,11.4287977 0.967717762,12.3965155 2.16145812,12.3965155 L7.61784299,12.3965155 C7.68707255,12.3966595 7.75204402,12.4299564 7.79258985,12.4860705 C7.83313568,12.5421845 7.84434904,12.6143249 7.82274922,12.6800988 C7.34547237,13.8898116 7.19055439,15.2027414 7.37316593,16.4903171 C7.88154088,18.3059419 8.9588116,18.8246919 9.80091569,18.7079732 C10.6577212,18.5626377 11.2735472,17.8039579 11.2395822,16.9355775 C11.2395822,14.5614319 13.0802799,11.9676822 14.727311,10.8307552 C14.8443685,10.74997 14.9140612,10.6167745 14.9140612,10.4745469 L14.9140612,1.72842277 C14.9140612,1.52130884 14.767246,1.34326404 14.5639048,1.3039124 C14.2788471,1.249325 13.9943828,1.1916828 13.7105611,1.13099575 C12.5471083,0.854250907 11.3547508,0.717541954 10.1588532,0.723777037 L4.53906205,0.723777037 C2.84620805,0.72464162 2.59374974,1.67222486 2.59374974,2.2376623 C2.59273239,2.537405 2.66108822,2.8333177 2.79346847,3.10224555 C1.84424508,3.58472835 1.45899619,4.74047501 1.92888522,5.69599529 C1.46093798,5.93374985 1.1089256,6.35051378 0.952792699,6.85163688 C0.796659802,7.35275998 0.849657597,7.8957113 1.09974989,8.35718252 C0.421806114,8.73948542 0.00174982594,9.45675135 0,10.2350573 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0625,10.0273846 C14.0625,10.377873 14.3822966,10.662 14.7767857,10.662 L17.0982143,10.662 C17.4927034,10.662 17.8125,10.377873 17.8125,10.0273846 L17.8125,3.04661538 C17.8125,2.69612699 17.4927034,2.412 17.0982143,2.412 L14.7767857,2.412 C14.3822966,2.412 14.0625,2.69612699 14.0625,3.04661538 L14.0625,10.0273846 Z M15.1339286,4.15719231 C15.1339286,3.89432601 15.373776,3.68123077 15.6696429,3.68123077 C15.9655097,3.68123077 16.2053571,3.89432601 16.2053571,4.15719231 C16.2053571,4.42005861 15.9655097,4.63315385 15.6696429,4.63315385 C15.373776,4.63315385 15.1339286,4.42005861 15.1339286,4.15719231 L15.1339286,4.15719231 Z",
    id: "Shape"
  })), /*#__PURE__*/React.createElement("g", {
    id: "ic_flag_24px",
    transform: "translate(3.000000, 0.750000)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsDown);
export default __webpack_public_path__ + "static/media/thumbsDown.442dcf2ccd3e3f133f02c87d1a1c6709.svg";
export { ForwardRef as ReactComponent };